export const getBaseUrl = () => {
  let url;
  switch (process.env.NODE_ENV) {
    case 'production':
      url = process.env.REACT_APP_PROD_API;
      break;
    case 'development':
    default:
      url = process.env.REACT_APP_DEV_API;
  }
  return url;
};
